import React, { FunctionComponent } from "react";
import classNames from "classnames";

interface InfoItemProps {
  heading: string | React.ReactElement;
  content: string | string[];
  className?: string;
}

const InfoItem: FunctionComponent<InfoItemProps> = ({
  heading,
  content,
  className,
}) => (
  <div className={classNames("infoItem", className)}>
    <h4 className="h4 ds-u-margin--0">{heading}</h4>
    {Array.isArray(content) ? (
      content.map((c, i) => (
        <p className="ds-text-body--md ds-u-margin--0" key={i}>
          {c}
        </p>
      ))
    ) : (
      <p className="ds-text">{content}</p>
    )}
  </div>
);

export default InfoItem;
